import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: object | object[];
}

export default function SchemaOrg({ schema }: SchemaOrgProps) {
  useEffect(() => {
    const schemaArray = Array.isArray(schema) ? schema : [schema];
    const scriptIds: string[] = [];

    schemaArray.forEach((schemaItem, index) => {
      const scriptId = `schema-org-${index}-${Date.now()}`;
      scriptIds.push(scriptId);

      let scriptElement = document.getElementById(scriptId) as HTMLScriptElement;
      
      if (!scriptElement) {
        scriptElement = document.createElement('script');
        scriptElement.id = scriptId;
        scriptElement.type = 'application/ld+json';
        document.head.appendChild(scriptElement);
      }
      
      scriptElement.textContent = JSON.stringify(schemaItem);
    });

    return () => {
      scriptIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.remove();
        }
      });
    };
  }, [schema]);

  return null;
}